import React from 'react';
import { Route } from 'react-router-dom';
import { AuthLayout } from '../layouts/AuthLayout';

const Login = React.lazy(() => import('../pages/Login').then((m) => ({ default: m.Login })));
const PasswordReset = React.lazy(() =>
  import('../pages/PasswordReset').then((m) => ({ default: m.PasswordReset })),
);
const ForgotPasswordPage = React.lazy(() =>
  import('../pages/ForgotPasswordPage').then((m) => ({ default: m.ForgotPasswordPage })),
);
const TermsPage = React.lazy(() =>
  import('../pages/TermsPage').then((m) => ({ default: m.TermsPage })),
);
const CookiePolicyPage = React.lazy(() =>
  import('../pages/CookiePolicyPage').then((m) => ({ default: m.CookiePolicyPage })),
);

/** Public auth routes — no authentication required. */
export function authRoutes() {
  return (
    <Route element={<AuthLayout />}>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/password-reset" element={<PasswordReset />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/cookie-policy" element={<CookiePolicyPage />} />
    </Route>
  );
}
